import React, { useId } from 'react'
import PropTypes from 'prop-types'
import cx from 'clsx'

import * as styles from '../../styles/components/floating-contact-button.module.scss'

const PANEL_ID = 'global-contact-form-panel'

const FloatingContactButton = ({ onClick, disabled = false, open = false }) => {
  const arcId = useId()
  const buttonClassName = cx(styles.floatingContactButton, {
    [styles.open]: open,
  })

  return (
    <button
      type="button"
      className={buttonClassName}
      aria-label={open ? 'Close contact form' : 'Open contact form'}
      aria-controls={PANEL_ID}
      aria-expanded={open}
      aria-pressed={open}
      onClick={onClick}
      disabled={disabled}
    >
      <span className={styles.floatingContactButtonLabel} aria-hidden="true">
        <svg viewBox="0 0 100 100" focusable="false">
          <defs>
            <path id={arcId} d="M 20 60 A 30 30 0 0 0 80 60" />
          </defs>
          <text>
            <textPath href={`#${arcId}`} startOffset="50%" textAnchor="middle">
              CONTACT
            </textPath>
          </text>
        </svg>
      </span>
      <span className={styles.floatingContactButtonIcon} aria-hidden="true">
        <svg viewBox="0 0 24 24" focusable="false">
          <path d="M9.707 5.293a1 1 0 010 1.414L5.414 11H21a1 1 0 110 2H5.414l4.293 4.293a1 1 0 01-1.414 1.414l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 0z" />
        </svg>
      </span>
      <span className={styles.srOnly}>Contact</span>
    </button>
  )
}

FloatingContactButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  open: PropTypes.bool,
}

export { PANEL_ID }
export default FloatingContactButton
